/**
 * test-session-memory.ts — what this browser remembers of the test session's
 * last join: the team code and the name, so the form opens with them and Join
 * takes the focus. Kept in local storage under keys spelled here alone — the
 * gallery's test session scenes put their own values in through these too.
 * No storage — a private window — and the form starts empty.
 */

const CODE_KEY = 'ts_last_team_code';
const NAME_KEY = 'ts_last_user_name';

/** What the form remembers: the last team code and name that joined, '' for either it has not. */
export function rememberedJoin(): { code: string; name: string } {
  try {
    return { code: localStorage.getItem(CODE_KEY) ?? '', name: localStorage.getItem(NAME_KEY) ?? '' };
  } catch {
    return { code: '', name: '' };
  }
}

/** Remember what joined, for the next time this browser opens the form; an empty value is forgotten. */
export function rememberJoin(code: string, name: string): void {
  try {
    for (const [key, value] of [
      [CODE_KEY, code],
      [NAME_KEY, name],
    ] as const) {
      if (value) localStorage.setItem(key, value);
      else localStorage.removeItem(key);
    }
  } catch {
    // No storage: the form starts empty next time.
  }
}
